import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
// store
import { useSelector, useDispatch, SET_DEVICE, SET_DEVICES, DELETE_DEVICE, DELETE_DEVICES } from '../../../store';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// sections
import MultipleField from './MultipleField';
// components
import Breadcrumbs from '../../../components/breadcrumbs';
// @devextreme
import { Popover } from 'devextreme-react/popover';
// styles
import { ListContainer, PrimaryButton, SelectButton, ButtonWrapper, TertiaryButton, Message } from '../../../styles';
// apis
import { getAlarmSettings, updateAlarmSettings, getDevicesInfo } from '../../../apis';

// ----------------------------------------------------------------------

export default function AlarmSettingPage() {
  
  const mobile = useResponsive('down', 'md');
  const navigate  = useNavigate();
  const dispatch = useDispatch();
  const group = useSelector((state) => state.group);
  const device = useSelector((state) => state.device);
  const devices = useSelector((state) => state.devices);

  const [ data, setData ] = useState({sensor: {}, prediction: {}});

  const [ visibleDevice, setVisibleDevice ] = useState(false);

  const [ message, setMessage ] = useState(null);

  useEffect(() => {
    if ( device?.iotDeviceId ) {
      ( async () =>
        await getAlarmSettings(device.iotDeviceId)
          .then((response) => {
            const alarm: any = { sensor: {}, prediction: {}};

            if ( response.sensorAlarmSettings.length > 0 ) {
              response.sensorAlarmSettings.forEach((value: any) => {
                alarm.sensor[value.waterQualitySensorId] = {
                  ...value,
                  id: value.waterQualitySensorId,
                  type: 'sensor',
                  error: false
                };
              });
            }
            
            if ( response.predictionAlarmSettings.length > 0 ) {
              response.predictionAlarmSettings.forEach((value: any) => {
                alarm.prediction[value.waterQualityPredictionId] = {
                  ...value,
                  id: value.waterQualityPredictionId,
                  type: 'prediction',
                  error: false
                }
              });
            }
            setData(alarm);
          })
          .catch(() => {
            setData({sensor: {}, prediction: {}});
          })
      )();
    }
  }, [device]);

  const handleSelection = (value: any) => {
    dispatch( SET_DEVICE(value) );
    setVisibleDevice(false);
  };

  const onSubmit = () => {
    const values = [ ...Object.values(data.sensor), ...Object.values(data.prediction) ];
    const errors = values.filter((value: any) => value.error);

    if ( errors.length > 0 ) return;

    const valueObj: any = {
      sensorAlarmSettings: [],
      predictionAlarmSettings: []
    };

    Object.values(data.sensor).forEach((value: any) => {
      valueObj.sensorAlarmSettings.push({
        waterQualitySensorId: value.waterQualitySensorId,
        alarmType: value.alarmType,
        alarmLowerLimit: value.alarmType === 'UPPER_LIMIT' || value.alarmType === 'OFF' ? null : value.alarmLowerLimit,
        alarmUpperLimit: value.alarmType === 'LOWER_LIMIT' || value.alarmType === 'OFF' ? null : value.alarmUpperLimit
      });
    });

    Object.values(data.prediction).forEach((value: any) => {
      valueObj.predictionAlarmSettings.push({
        waterQualityPredictionId: value.waterQualityPredictionId,
        alarmType: value.alarmType,
        alarmLowerLimit: value.alarmType === 'UPPER_LIMIT' || value.alarmType === 'OFF' ? null : value.alarmLowerLimit,
        alarmUpperLimit: value.alarmType === 'LOWER_LIMIT' || value.alarmType === 'OFF' ? null : value.alarmUpperLimit
      });
    });
    
    updateAlarmSettings(device.iotDeviceId, valueObj)
      .then( async () => {
        await getDevicesInfo(group.id)
          .then((response) => {
            if ( response.length > 0 ) {
              dispatch( SET_DEVICES(response) );
              dispatch( SET_DEVICE(response.find((element: any) => { return element.iotDeviceId === device.iotDeviceId })) );
            } else {
              dispatch( DELETE_DEVICES() );
              dispatch( DELETE_DEVICE() );
            }
          })
          .catch(() => {
            dispatch( DELETE_DEVICES() );
            dispatch( DELETE_DEVICE() );
          })
        navigate('/alarm');
      })
      .catch(() => {
        setMessage('알람 수정을 할 수 없습니다. 나중에 다시 시도해 주세요.')
      })
  };

  return (
    <ListContainer>
      <Breadcrumbs
        heading='알람 설정'
        links={[
          {name: '알람', link: '/alarm'},
          {name: '알람 설정'}
        ]}
      />

      { mobile &&
        <SelectButton type='button' id='device' onClick={() => setVisibleDevice(true)} disabled={!device ? true : false} style={{'width': '100%'}}>{ device?.location }<div/></SelectButton>
      }
      <Popover
        target='#device'
        visible={visibleDevice}
        hideOnOutsideClick={true}
        onHiding={() => setVisibleDevice(false)}
        wrapperAttr={{'class': 'mobilePopover'}}
      >
        { devices.map((item: any) => (
          <button type='button' key={item.iotDeviceId} onClick={() => handleSelection(item)}>
            { item.location }
          </button>
        ))}
      </Popover>

      <form>
        { !device &&
          <p>등록된 IoT 장비가 없습니다.</p>
        }
        { Object.values(data.sensor).length > 0 && Object.values(data.sensor).map((sensor: any, index: number) => (
          <MultipleField key={index} value={sensor} data={data} setData={setData} />
        ))}
        { Object.values(data.prediction).length > 0 && Object.values(data.prediction).map((sensor: any, index: number) => (
          <MultipleField key={index} value={sensor} data={data} setData={setData} />
        ))}
                      
        <Message $visible={message ? true : false}>{ message }</Message>
        
        <ButtonWrapper>
          <PrimaryButton type='button' onClick={() => onSubmit()} disabled={device ? false : true}>저장</PrimaryButton>
          <TertiaryButton type='button' onClick={() => navigate('/alarm')}>취소</TertiaryButton>
        </ButtonWrapper>
      </form>
    </ListContainer>
  );
}